import { Navigate, RouteObject } from 'react-router-dom';
import {
    PointagePage,
    MenuRichessesHumainesPage,
    PointageActionPage,
    MesCongesPage,
    CarteBtpPage,
    NewCongePage,
    UpdateCongePage,
    EventFeedbackPage,
    BibliothequePage
} from '@pages';

export const richessesHumainesRoutes = (isLogged: boolean | null | undefined): RouteObject[] => [
    {
        path: '/richesses-humaines',
        element: isLogged ? <MenuRichessesHumainesPage /> : <Navigate to="/login" replace />
    },
    {
        path: '/richesses-humaines/pointage',
        element: isLogged ? <PointagePage /> : <Navigate to="/login" replace />
    },
    {
        path: '/richesses-humaines/pointage/:id',
        element: isLogged ? <PointageActionPage /> : <Navigate to="/login" replace />
    },
    {
        path: '/richesses-humaines/bibliotheque',
        element: isLogged ? <BibliothequePage type="rh" /> : <Navigate to="/login" replace />
    },
    {
        path: '/richesses-humaines/conges',
        element: isLogged ? <MesCongesPage /> : <Navigate to="/login" replace />
    },
    {
        path: '/richesses-humaines/conges/new',
        element: isLogged ? <NewCongePage /> : <Navigate to="/login" replace />
    },
    {
        path: '/richesses-humaines/conges/:holidayId',
        element: isLogged ? <UpdateCongePage /> : <Navigate to="/login" replace />
    },
    {
        path: '/richesses-humaines/carte-btp',
        element: isLogged ? <CarteBtpPage /> : <Navigate to="/login" replace />
    },
    {
        path: '/richesses-humaines/event-feedback',
        element: isLogged ? <EventFeedbackPage eventDestination="rh" /> : <Navigate to="/login" replace />
    }
];
